import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import Select from 'react-select';
import { Field } from '../../../ui/Field';
import moment from 'moment';
import { SPECS, ROLES } from './CreateMeter';
import UpdatePage from '../../../composents/UpdatePage';

const title = 'Meters';
const headers = {
	icon: 'feather icon-edit',
	title: title,
	description: 'update of meter',
	breadcrumbs: [
		{
			title: title,
			link: '/meters/meters',
		},
	],
};

export default function EditMeter() {
	const [loader, setLoader] = useState(false),
		{ id } = useParams(),
		[data, setData] = useState({}),
		[spec, setSpec] = useState(),
		[role, setRole] = useState(),
		[errors, setErrors] = useState({}),
		[zone, setZone] = useState([]),
		[zones, setZones] = useState([]),
		[clients, setClients] = useState([]),
		[fail, setFail] = useState(false),
		[loading, setLoading] = useState(true),
		[client, setClient] = useState();

	async function onGet() {
		setLoading(true);
		let zone = await resources.meter
			.readOne(id)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (zone.status === 200) {
			setData(zone.data);
			const meterRole = ROLES.filter((r) => r.value === zone.data.role);
			if (meterRole.length !== 0) {
				setRole(meterRole[0]);
			}

			const meterSystemSpecs = SPECS.filter(
				(r) => r.value === zone.data.systemSpecs
			);
			if (meterSystemSpecs.length !== 0) {
				setSpec(meterSystemSpecs[0]);
			}
		} else if (zone.status === 403) {
			setFail(true);
		}
		let clientsFromApi = await resources.customer
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (clientsFromApi.status === 200) {
			let covertaToLabelValue = [];
			clientsFromApi.data.docs.forEach((el) => {
				if (zone.data.client === el.id) {
					setClient({
						value: el.id,
						label: el.name,
					});
				}
				covertaToLabelValue.push({
					value: el.id,
					label: el.name,
				});
			});
			setClients(covertaToLabelValue);
		}

		let zonesFromApi = await resources.zone
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (zonesFromApi.status === 200) {
			let covertaToLabelValue = [];
			zonesFromApi.data.docs.forEach((el) => {
				if (zone.data.zone === el.id) {
					setZone({
						value: el.id,
						label: el.zone + ' | ' + el.location,
						client: el.client.id,
					});
				}
				covertaToLabelValue.push({
					value: el.id,
					label: el.zone + ' | ' + el.location,
					client: el.client.id,
				});
			});
			setZones(covertaToLabelValue);
		}
		setLoading(false);
	}

	useEffect(() => {
		onGet();
	}, []);

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		if (zone) object.zone = zone.value;
		if (client) object.client = client.value;
		object.date = moment(object.date).format('DD-MM-YYYY');
		setLoader(true);
		setErrors({});
		let res = await resources.meter
			.update(id, object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/meters/meters');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	const filterZone = () => {
		let all_cities = [];
		if (client) {
			all_cities = zones.filter((e) => e.client == client.value);
		}
		return all_cities;
	};

	return (
		<UpdatePage
			show_error={errors['not_autorized']}
			loading={loading}
			fail={fail}
			headers={headers}
		>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<div className="mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Client{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={(e) => setClient(e)}
										options={clients}
										value={client}
										isSearchable
										isClearable
										className={
											errors['client']
												? ' is-invalid'
												: ''
										}
									/>
									{errors['client'] && (
										<div className="invalid-feedback">
											{errors['client']}
										</div>
									)}
								</div>

								<Field
									name="meter_name"
									className="mb-3"
									error={errors['meter_name']}
									required
									defaultValue={data.meter_name}
								>
									Meter name
								</Field>

								<Field
									name="mac"
									className="mb-3"
									error={errors['mac']}
									required
									defaultValue={data.mac}
								>
									Mac
								</Field>

								<div className="mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Zone{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={(e) => setZone(e)}
										options={filterZone()}
										value={zone}
										isSearchable
										isClearable
										className={
											errors['zone'] ? ' is-invalid' : ''
										}
									/>
									{errors['zone'] && (
										<div className="invalid-feedback">
											{errors['zone']}
										</div>
									)}
								</div>

								<div className="mb-3">
									<label
										name="typeOfNetwork"
										htmlFor="typeOfNetwork"
										className="form-label"
									>
										Network mode
										<span style={{ color: 'red' }}>*</span>
									</label>
									<select
										name="typeOfNetwork"
										class={
											errors['typeOfNetwork']
												? 'form-select is-invalid'
												: 'form-select'
										}
										aria-label="Default select example"
									>
										<option
											value="wifi"
											selected={
												data.typeOfNetwork === 'wifi'
											}
										>
											wifi
										</option>
										<option
											value="wifi mesh"
											selected={
												data.typeOfNetwork ===
												'wifi mesh'
											}
										>
											wifi mesh
										</option>
										<option
											value="Bluetooth"
											selected={
												data.typeOfNetwork ===
												'Bluetooth'
											}
										>
											Bluetooth
										</option>
										<option
											value="Bluetooth mesh"
											selected={
												data.typeOfNetwork ===
												'Bluetooth mesh'
											}
										>
											Bluetooth mesh
										</option>
									</select>
									{errors['typeOfNetwork'] && (
										<div className="invalid-feedback">
											{errors['typeOfNetwork']}
										</div>
									)}
								</div>

								<div className="mb-3">
									<label
										htmlFor="typeOfNetworkTopo"
										className="form-label"
									>
										Network topology
										<span style={{ color: 'red' }}>*</span>
									</label>
									<select
										class={
											errors['typeOfNetworkTopo']
												? 'form-select is-invalid'
												: 'form-select'
										}
										aria-label="Default select example"
										name="typeOfNetworkTopo"
									>
										<option
											value="Wifi AP"
											selected={
												data.typeOfNetworkTopo ===
												'Wifi AP'
											}
										>
											Wifi AP
										</option>
										<option
											value="Mesh network"
											selected={
												data.typeOfNetworkTopo ===
												'Mesh network'
											}
										>
											Mesh network
										</option>
										<option
											value="Start network"
											selected={
												data.typeOfNetworkTopo ===
												'Start network'
											}
										>
											Start network
										</option>
										<option
											value="Coordinator"
											selected={
												data.typeOfNetworkTopo ===
												'Coordinator'
											}
										>
											Coordinator
										</option>
									</select>
									{errors['typeOfNetworkTopo'] && (
										<div className="invalid-feedback">
											{errors['typeOfNetworkTopo']}
										</div>
									)}
								</div>

								<div className="mb-3">
									<label
										htmlFor="workingMode"
										className="form-label"
									>
										Working Mode
										<span style={{ color: 'red' }}>*</span>
									</label>
									<select
										class={
											errors['workingMode']
												? 'form-select is-invalid'
												: 'form-select'
										}
										aria-label="Default select example"
										name="workingMode"
									>
										<option
											value="Unique mode"
											selected={
												data.workingMode ===
												'Unique mode'
											}
										>
											Unique mode
										</option>
										<option
											value="Dual mode"
											selected={
												data.workingMode === 'Dual mode'
											}
										>
											Dual mode
										</option>
										<option
											value="Coordinator mode"
											selected={
												data.workingMode ===
												'Coordinator mode'
											}
										>
											Coordinator mode
										</option>
									</select>
									{errors['workingMode'] && (
										<div className="invalid-feedback">
											{errors['workingMode']}
										</div>
									)}
								</div>

								<div className="mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Role
									</label>
									<Select
										name="role"
										options={ROLES}
										isSearchable
										isClearable
										onChange={setRole}
										value={role}
										className={
											errors['role'] ? ' is-invalid' : ''
										}
									/>
									{errors['role'] && (
										<div className="invalid-feedback">
											{errors['role']}
										</div>
									)}
								</div>

								<div className="mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										System Specs
									</label>
									<Select
										name="systemSpecs"
										options={SPECS}
										isSearchable
										isClearable
										onChange={setSpec}
										value={spec}
										className={
											errors['systemSpecs']
												? ' is-invalid'
												: ''
										}
									/>
									{errors['systemSpecs'] && (
										<div className="invalid-feedback">
											{errors['systemSpecs']}
										</div>
									)}
								</div>
								<Field
									name="numero_de_serie"
									className="mb-3"
									error={errors['numero_de_serie']}
									required
									defaultValue={data.numero_de_serie}
								>
									serial number
								</Field>

								<Field
									name="DNID"
									className="mb-3"
									error={errors['DNID']}
									defaultValue={data.DNID}
								>
									DNID
								</Field>

								<Field
									name="HotspotName"
									className="mb-3"
									error={errors['HotspotName']}
									defaultValue={data.HotspotName}
								>
									network ssid
								</Field>

								<Field
									name="HotsPassword"
									className="mb-3"
									error={errors['HotsPassword']}
									defaultValue={data.HotsPassword}
								>
									network password
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary "
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</UpdatePage>
	);
}
